import { computed } from '@ember/object';
import TextBlock from './text-block';
import BlockRange from '@intercom/embercom-composer/blocks/block-range';
import BlockMutationResult from '@intercom/embercom-composer/blocks/block-mutation-result';
import AlignableBlock from '../mixins/alignable-block';
import AttributeReplacement from '@intercom/embercom-composer/blocks/replacements/attribute';
import LinkReplacement from '@intercom/embercom-composer/blocks/replacements/link';
import Em from 'ember';
export default TextBlock.extend(AlignableBlock, {
  isHeadingType: true,
  openingTag: computed('tagName', 'id', 'generatedAt', 'align', function () {
    return `<${this.tagName} data-id="${this.id}" data-generated-at="${this.generatedAt}" data-align="${this.align}">`;
  }),
  allowedEntities: ['attribute', 'anchor'],
  inlineReplacements: [LinkReplacement, AttributeReplacement],
  serialized: Em.computed('serializedInnerHtml', 'align', function () {
    let serialized = this._super();
    if (this.get('config.allowAlignment')) {
      serialized.align = this.get('align');
    }
    return serialized;
  }),
  init() {
    this._super();
  },
  split(blockRange) {
    if (blockRange.get('startPoint.positionIndex') === this.get('text.length')) {
      this.set('splitType', 'paragraph');
    } else {
      this.set('splitType', this.get('type'));
    }
    let newBlock = this._super(blockRange);
    if (this.get('splitType') === 'paragraph') {
      newBlock.set('align', 'left');
    }
    this.doInlineReplacements();
    return newBlock;
  },
  join(block) {
    if (block.get('isTextType')) {
      return this._joinWithTextBlock(block);
    }
    return this._super(block);
  },
  _joinWithTextBlock(block) {
    let blocksToRemove = [];
    let text = this.get('text');
    let newEntities = this._joinEntitiesFromRight(block, ['anchor', 'attribute']);
    this.set('entities', newEntities);
    this.set('text', text + block.get('text'));
    blocksToRemove.pushObject(block);
    return BlockMutationResult.create({
      blocksToRemove,
      blockRange: BlockRange.atPositionIndex(text.length)
    });
  }
});